import { useQuery, useQueryClient } from '@tanstack/react-query';
import { importBatchApiService } from '@/services/importBatchApiService';
import { getAuthState } from '@/contexts/AuthContext';

export function useImportBatches() {
  const { isAuthenticated } = getAuthState();
  return useQuery({
    queryKey: ['importBatches'],
    queryFn: () => importBatchApiService.list(),
    enabled: isAuthenticated,
  });
}

export function useImportBatchMutations() {
  const queryClient = useQueryClient();

  const deleteImportBatch = async (id: string) => {
    await importBatchApiService.delete(id);
    queryClient.invalidateQueries({ queryKey: ['importBatches'] });
    queryClient.invalidateQueries({ queryKey: ['payouts'] });
  };

  return { deleteImportBatch };
}
